import React from "react";
import classNames from "lib/classNames";

const SetupStep = ({
  title,
  description,
  required,
  recommended,
  actionText,
  action,
  done,
}) => {
  return (
    <div
      className={classNames(
        "flex items-center justify-between pt-4 pb-4 border-gray-400 border-solid border-b"
      )}
    >
      <div style={{ width: "75%" }}>
        <div className={classNames("flex items-center justify-start mb-3")}>
          <b
            className={classNames(
              `font-medium text-gray-600 ${done ? "line-through" : ""}`
            )}
          >
            {title}
          </b>
          {(required || recommended) && (
            <div
              className={classNames("ml-6")}
              style={{
                borderRadius: "13px",
                padding: "1px 16px",
                background: done
                  ? "#48bb78"
                  : required
                  ? "rgba(255, 0, 0, 0.4)"
                  : "#4399E0",
              }}
            >
              <b className={classNames("font-bold text-white text-sm")}>
                {done ? "Completed" : required ? "Required" : "Recommended"}
              </b>
            </div>
          )}
        </div>
        <p
          className={classNames(
            `whitespace-pre-wrap text-sm leading-5 text-gray-600 ${
              done ? "line-through" : ""
            }`
          )}
        >
          {description}
        </p>
      </div>
      <button
        className={classNames(
          "border-gray-400 border-solid border rounded-md capitalize font-bold text-sm text-center text-gray-600 py-1 px-5 no-outline focus:outline-none"
        )}
        onClick={action}
      >
        {actionText}
      </button>
    </div>
  );
};

export default SetupStep;
